import { render, staticRenderFns } from "./MyCalendar.vue?vue&type=template&id=37cc6230&"
import script from "./MyCalendar.vue?vue&type=script&lang=js&"
export * from "./MyCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports